import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../../../shared/shared.module';
import { AnnotationLayoutComponent } from './layout/annotation-layout.component';
import { FocusableScrubberComponent } from './toolbars/focusable-scrubber/focusable-scrubber.component';
import { ScrubberCursorComponent } from './toolbars/focusable-scrubber/scrubber-cursor/scrubber-cursor.component';
import { FocusableTimelineComponent } from './toolbars/focusable-timeline/focusable-timeline.component';
import { FocusedAreaComponent } from './toolbars/focused-area/focused-area.component';
import { FocusedTimelineComponent } from './toolbars/focused-timeline/focused-timeline.component';
import { FrameLoadingBarComponent } from './toolbars/frame-loading-bar/frame-loading-bar.component';
import { FrameComponent } from './toolbars/frame/frame.component';
import { ObjectlessShapeLabelComponent } from './toolbars/objectless-shape-label/objectless-shape-label.component';
import { PointCloudSecondaryToolbarComponent } from './toolbars/point-cloud-secondary-toolbar/point-cloud-secondary-toolbar.component';
import { RightCollapsingButtonComponent } from './toolbars/right-collapsing-panel/right-collapsing-button/right-collapsing-button.component';
import { RightCollapsingPanelComponent } from './toolbars/right-collapsing-panel/right-collapsing-panel.component';
import { SecondaryToolbar2dComponent } from './toolbars/secondary-toolbar2d/secondary-toolbar-2d.component';
import { FocusedAnnotationLabelComponent } from './toolbars/shape-list-and-tag-editor/object-list/annotation-label/focused-annotation-label.component';
import { MainPointCloudToolbarComponent } from './toolbars/split-view-point-cloud-toolbar/main-point-cloud-toolbar.component';
import { MainVideoToolbarComponent } from './toolbars/split-view-video-toolbar/main-video-toolbar.component';
import { EnhancedPointCloudButtonComponent } from './toolbars/static-toolbar/enhanced-point-cloud-button/enhanced-point-cloud-button.component';
import { HelpButtonComponent } from './toolbars/static-toolbar/help-button.component';
import { InspectButtonComponent } from './toolbars/static-toolbar/inspect-button.component';
import { ResetSensorViewButtonComponent } from './toolbars/static-toolbar/reset-zoom-camera/reset-sensor-view-button.component';
import { SyncSubpointShapesButtonComponent } from './toolbars/static-toolbar/sync-subpoint-shapes-button.component';
import { TogglePointCloudProjectionButtonComponent } from './toolbars/static-toolbar/toggle-point-cloud-projection-button/toggle-point-cloud-projection-button.component';
import { ToggleShapeProjectionButtonComponent } from './toolbars/static-toolbar/toggle-shape-projection-button/toggle-shape-projection-button.component';
import { ToggleSplitViewButtonComponent } from './toolbars/static-toolbar/toggle-split-view-button/toggle-split-view-button.component';
import { ToggleViewModesButtonComponent } from './toolbars/static-toolbar/toggle-view-modes-button/toggle-view-modes-button.component';
import { ToggleZoomPanelComponent } from './toolbars/static-toolbar/toggle-zoom-panel/toggle-zoom-panel.component';
import { UndoRedoButtonsComponent } from './toolbars/static-toolbar/undo-redo-buttons.component';
import { EditTool2dSecondaryToolbarComponent } from './toolbars/tool-secondary-toolbars/edit-tool-2d-secondary-toolbar/edit-tool-2d-secondary-toolbar.component';
import { EditTool3dSecondaryToolbarComponent } from './toolbars/tool-secondary-toolbars/edit-tool-3d-secondary-toolbar/edit-tool-3d-secondary-toolbar.component';
import { MeasureTool3dSecondaryToolbarComponent } from './toolbars/tool-secondary-toolbars/measure-tool-3d-secondary-toolbar/measure-tool-3d-secondary-toolbar.component';

const exportedItems = [
  AnnotationLayoutComponent,
  EnhancedPointCloudButtonComponent,
  FocusableScrubberComponent,
  FocusableTimelineComponent,
  FocusedTimelineComponent,
  FrameLoadingBarComponent,
  HelpButtonComponent,
  InspectButtonComponent,
  ObjectlessShapeLabelComponent,
  PointCloudSecondaryToolbarComponent,
  ResetSensorViewButtonComponent,
  RightCollapsingButtonComponent,
  RightCollapsingPanelComponent,
  ObjectlessShapeLabelComponent,
  SecondaryToolbar2dComponent,
  MainPointCloudToolbarComponent,
  MainVideoToolbarComponent,
  SyncSubpointShapesButtonComponent,
  TogglePointCloudProjectionButtonComponent,
  ToggleShapeProjectionButtonComponent,
  ToggleSplitViewButtonComponent,
  ToggleViewModesButtonComponent,
  ToggleZoomPanelComponent,
  UndoRedoButtonsComponent,
];

@NgModule({
  declarations: [
    exportedItems,
    EditTool3dSecondaryToolbarComponent,
    FocusableTimelineComponent,
    FocusedAreaComponent,
    FocusedTimelineComponent,
    FrameComponent,
    FocusedAnnotationLabelComponent,
    MeasureTool3dSecondaryToolbarComponent,
    ScrubberCursorComponent,
    EditTool2dSecondaryToolbarComponent,
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    MatButtonToggleModule,
    MatTooltipModule,
    SharedModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatMenuModule,
  ],
  exports: [exportedItems],
})
export class AnnotationSharedModule {}
